import { BasketStoreModel } from '@agent/core/basket/basket.model';
import { copy } from 'angular';

import { ChannelType } from '@contact/upgrade';

import { toChannelReducer } from '../basket.store';
import { ActionsUnion, ActionTypes } from './mail-basket.action';
import { INITIAL_STATE_QUERY_FILTER, MailChannelModel, QueryFilterModel, QuickFilterModel } from './mail-basket.model';

/**
 * Main reducer to manage
 */
export function mailReducer(state: BasketStoreModel, action: ActionsUnion): BasketStoreModel {
  // convert mail channel reducer
  return toChannelReducer(ChannelType.MAIL, mailChannelReducer)(state, action);
}

/**
 * Sub reducer to manage request filters
 */
export function mailChannelReducer(state: MailChannelModel, action: ActionsUnion): MailChannelModel {
  switch (action.type) {
    case ActionTypes.CHANGE_QUERY_FILTER:
    case ActionTypes.RESET_QUERY_FILTER: {
      return {
        ...state,
        channel: ChannelType.MAIL,
        queryFilters: queryFiltersReducer(state.queryFilters, action),
      };
    }
    case ActionTypes.CHANGE_QUICK_FILTER: {
      return {
        ...state,
        quickFilters: quickFiltersReducer(state.quickFilters, action),
      };
    }
    default:
      return state;
  }
}

/**
 * Sub reducer to manage query filters
 */
export function queryFiltersReducer(state: QueryFilterModel, action: ActionsUnion): QueryFilterModel {
  switch (action.type) {
    case ActionTypes.CHANGE_QUERY_FILTER: {
      const { filters } = action;
      return {
        ...state,
        ...filters,
      };
    }
    case ActionTypes.RESET_QUERY_FILTER:
      return copy(INITIAL_STATE_QUERY_FILTER);
    default:
      return state;
  }
}

export function quickFiltersReducer(state: QuickFilterModel, action: ActionsUnion): QuickFilterModel {
  switch (action.type) {
    case ActionTypes.CHANGE_QUICK_FILTER: {
      const { quickFilters } = action;
      return {
        ...state,
        ...quickFilters,
      };
    }
    default:
      return state;
  }
}
